export const isTemporaryContactId = (id) =>
    typeof id === "number" && id >= 1 && id <= 10;

export const prepareContactsForFinalSubmit = (contacts) =>
    Array.isArray(contacts)
        ? contacts.map((contact) =>
              isTemporaryContactId(contact.id)
                  ? { ...contact, id: 0 }
                  : contact
          )
        : [];

export const mapContactServerErrors = (errorObj) => {
    if (!errorObj || typeof errorObj !== "object") return {};

    const fieldMappings = {
        Name: "name",
        LastName: "lastname",
        Email: "email",
        Phone: "phone",
        Title: "title",
    };

    return Object.entries(fieldMappings).reduce(
        (contactErrors, [serverField, clientField]) => {
            if (
                Array.isArray(errorObj[serverField]) &&
                errorObj[serverField].length > 0
            ) {
                contactErrors[clientField] = errorObj[serverField][0];
            }
            return contactErrors;
        },
        {}
    );
};
